<div class="card">
  <div class="card__body">
    <i>
      <svg-icon src="assets/images/icons/icon-info.svg"></svg-icon>
    </i>
    <h3>{{ "Subscription.TerminatedInfo.Title" | translate }}</h3>
    <p>{{ "Subscription.TerminatedInfo.Description" | translate }} {{ date() }}</p>
  </div>
</div>
